import {
  AlertTriangle,
  Ban,
  CheckCircle2,
  CircleDashed,
  Clock,
  Loader2,
  MailQuestion,
  Wallet,
} from "lucide-react";
import type { InboundEmailStatus } from "../types";

type Look = { cls: string; icon: typeof Clock };

/** Jeden język kolorów dla statusu: czerwień = wymaga człowieka, zieleń = zrobione,
 * szarość = nic tu po tobie. Kwadratowe kafelki, zgodnie z resztą panelu. */
const LOOK: Record<InboundEmailStatus, Look> = {
  received: { cls: "border-gray-300 bg-gray-50 text-gray-600", icon: Clock },
  unmatched: {
    cls: "border-amber-300 bg-amber-50 text-amber-800",
    icon: MailQuestion,
  },
  processing: { cls: "border-red-300 bg-red-50 text-red-700", icon: Loader2 },
  answered: {
    cls: "border-emerald-300 bg-emerald-50 text-emerald-700",
    icon: CheckCircle2,
  },
  reply_failed: {
    cls: "border-red-400 bg-red-50 text-red-700",
    icon: AlertTriangle,
  },
  budget_deferred: {
    cls: "border-amber-300 bg-amber-50 text-amber-800",
    icon: Wallet,
  },
  cancelled: { cls: "border-gray-300 bg-gray-50 text-gray-500", icon: Ban },
  error: { cls: "border-red-400 bg-red-50 text-red-700", icon: AlertTriangle },
};

const FALLBACK: Look = {
  cls: "border-gray-300 bg-gray-50 text-gray-600",
  icon: CircleDashed,
};

export function AronMailStatusBadge({
  status,
  label,
  /** Wersja na listę: sama ikona, opis w dymku — wiersz ma zostać jednolinijkowy. */
  compact = false,
}: {
  status: InboundEmailStatus;
  label: string;
  compact?: boolean;
}) {
  const look = LOOK[status] ?? FALLBACK;
  const Icon = look.icon;
  const spin = status === "processing" ? "animate-spin" : "";
  if (compact) {
    const tone = look.cls.split(" ").find((c) => c.startsWith("text-")) ?? "";
    return (
      <span title={label} aria-label={label} className="mt-0.5 inline-flex shrink-0">
        <Icon size={12} className={`${spin} ${tone}`} />
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 border px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wide uppercase ${look.cls}`}
    >
      <Icon size={11} className={spin} /> {label}
    </span>
  );
}
